import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-refer-app',
  templateUrl: './refer-app.component.html',
  styleUrls: ['./refer-app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferAppComponent implements OnInit {
  referCode:String;
  constructor(private toastr: ToastrService) { }

  ngOnInit() {
    this.referCode ='https://somelink.com/fsdff/sfs6fd6f4d6f4/f4d6f4d6fd';
  }

  copyText(link:string){
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success('Link copied successfully', 'Success');
  }

}
